export const commonSiteConfig = {
  links: {
    x: "https://twitter.com/CraftStadium",
    discord: "https://discord.gg/kQvdQEa4uD",
    sponsor: "https://forms.gle/TTsfjLrxg658Q9u69",
    media_kit:
      "https://drive.google.com/drive/folders/1Gzv9EP037sZaOTnuqsyEncxSw7RPvZKa?usp=sharing",
  },
}
